import { BaseQueryOpts } from '../baseTypes';
import { useQuery } from '@tanstack/react-query';
import { getSessionByAppointmentId } from '@uplift/api';


export const useSessionByAppointmentIdQuery = (appointmentId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'appointment', appointmentId, 'session' ],
    queryFn: async () => {
      const sessionResponse = await getSessionByAppointmentId(appointmentId);

      return sessionResponse.data;
    },
    ...opts
  });
};
